import type { ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { FormGroupContainer } from '@/components/FormContainer'
import type { RynoEditorViewModel } from '@/features/legends/ryno/RynoEditorViewModel'
import { RynoEditorContainer } from '@/features/legends/ryno/components/RynoEditor/RynoEditorContainer'

export interface FormulaFieldContainerProps {
  vm: RynoEditorViewModel
  label?: string
  help?: ReactNode
  error?: string
  isDisabled?: boolean
  /**
   * Defaults to the label.
   */
  'aria-label'?: string
  testId?: string
}

/**
 * A labelled Ryno formula.
 */
export const FormulaFieldContainer = observer(function FormulaFieldContainer({
  vm,
  label,
  help,
  error,
  isDisabled,
  'aria-label': ariaLabel = label,
  testId,
}: FormulaFieldContainerProps) {
  return (
    <FormGroupContainer label={label} help={help} error={error}>
      <RynoEditorContainer
        vm={vm}
        isDisabled={isDisabled}
        aria-label={ariaLabel}
        testId={testId}
      />
    </FormGroupContainer>
  )
})
